/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputZoneRequestsOtgsSelector
 */
export interface OutputZoneRequestsOtgsSelector {
    /**
     * 
     * @type {number}
     * @memberof OutputZoneRequestsOtgsSelector
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputZoneRequestsOtgsSelector
     */
    name: string;
}

/**
 * Check if a given object implements the OutputZoneRequestsOtgsSelector interface.
 */
export function instanceOfOutputZoneRequestsOtgsSelector(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputZoneRequestsOtgsSelectorFromJSON(json: any): OutputZoneRequestsOtgsSelector {
    return OutputZoneRequestsOtgsSelectorFromJSONTyped(json, false);
}

export function OutputZoneRequestsOtgsSelectorFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputZoneRequestsOtgsSelector {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputZoneRequestsOtgsSelectorToJSON(value?: OutputZoneRequestsOtgsSelector | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

